import { useCallback } from 'react';

import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { setGameWindowContext } from '@/store/actions';
import getBalanceData from './get-balance-data';

export const useReloadBalance = () => {
  const { emitClientEvent } = useEventManagerEmitter();

  return useCallback(
    () =>
      getBalanceData((balance) => {
        setGameWindowContext({ balance });
        emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.RELOAD_BALANCE, balance);
      }),
    [emitClientEvent],
  );
};

export default useReloadBalance;
